import { Image } from 'antd';
import './SelectionSuplier.scss';
import { Icon } from '../../../../components/icon/icon';
import { cn } from '../../../../utils/string/cn.utils';
import ButtonTertiarySmall from '../../../../components/common/ButtonTertiary/ButtonTertiarySmall';
import { t } from 'i18next';

const SelectionSupplier = ({
  src,
  title,
  description,
  className,
  onClick,
  active,
  actions,
  icon,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(
        'flex px-[12px] py-[8px] items-center gap-[8px] rounded-[8px] border-[1px] border-solid bg-fills-white selection-suplier border-outline-default-secondary hover:border-outline-brand-primary hover:bg-primary-primary-fill transition-all duration-300 ease-in-out',
        className,
        active ? 'border-outline-brand-primary bg-primary-primaryFill' : ''
      )}
      onClick={onClick}
    >
      <div className="flex w-[32px] h-[32px] items-center justify-center">
        {src ? <img className="w-full object-fit-contain" src={src} /> : icon}
      </div>
      <div className="flex flex-col justify-start items-start flex-1 text-black-high gap-[4px]">
        <span className="text-label-large font-semibold line-clamp-1">
          {title}
        </span>

        <span className="text-body-small truncate">{description}</span>
      </div>
      {actions}
    </div>
  );
};

export default SelectionSupplier;
